import { Children, Fragment, ReactElement, ReactNode, isValidElement } from 'react';

export function checkFragment(children: ReactElement): children is ReactElement<{ children?: ReactNode }> {
  return children.type === Fragment;
}

export function flattenFragment(children: ReactNode): ReactElement[] {
  const childArray: ReactElement[] = [];
  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;

    if (checkFragment(child)) {
      childArray.push(...flattenFragment(child.props.children));
    } else {
      childArray.push(child);
    }
  });
  return childArray;
}
